/**
 * The Z6 tool rail (S5): a 44 px strip at the right edge of the content area, desktop only.
 * One icon button per shown tool, in the user's order; the tooltip is the label (and the
 * reason, when the tool is unavailable here); aria-pressed marks the open one; a click toggles
 * the panel. Tokens only.
 */
import './tools.css';

export default function ToolRail({ tools, ctx, openId, onToggle }) {
  return (
    <div role="toolbar" aria-label="Tools" aria-orientation="vertical" className="tool-rail">
      {tools.map((tool) => {
        const available = tool.availableFor(ctx);
        const ok = available === true;
        const Icon = tool.icon;
        return (
          <button
            key={tool.id}
            type="button"
            className="tool-rail-button"
            aria-label={tool.label}
            title={ok ? tool.label : `${tool.label}: ${available}`}
            aria-pressed={openId === tool.id}
            disabled={!ok}
            data-tool-trigger=""
            onClick={(e) => onToggle(tool.id, e.currentTarget)}
          >
            <Icon aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
